import isEqual from 'lodash/isEqual';
import React, { useState } from 'react';

import { StyledCollapseButton, StyledText, Wrapper } from './styled';

type Props = {
  data: string[];
  testId?: string;
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
};

//TODO: ask about virtualization

const Collapse: React.FC<Props> = ({ data, testId = 'collapseItem', size = 'large', showTooltip = false }) => {
  const [showAll, setShowAll] = useState<boolean>(false);

  const toggleView: VoidFunction = () => setShowAll(!showAll);

  const title = showAll ? 'Collapse' : 'View All';

  const amountToShow = showAll ? data.length : 3;

  return (
    <Wrapper>
      {data.slice(0, amountToShow).map((item, index) => (
        <StyledText title={showTooltip ? item : undefined} key={`${index}-${testId}`} data-testid={testId}>
          {item}
        </StyledText>
      ))}

      {data.length > 3 && (
        <StyledCollapseButton data-testid="collapseToggleButton" $size={size} onClick={toggleView}>
          {title}
        </StyledCollapseButton>
      )}
    </Wrapper>
  );
};

export default React.memo(Collapse, isEqual);
